import DocsIndexFeature from '../../features/docs/docs-index-feature';

export default function DocsIndexPage() {
  return <DocsIndexFeature />;
}
